import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import OrdersPaymentsRouteView from './OrdersPaymentsRouteView.vue';
import OrdersPaymentsInboxListPage from './OrdersPaymentsInboxListPage.vue';
import OrdersListPage from './OrdersListPage.vue';
import OrdersDetailPage from './OrdersDetailPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.WHATSAPP_PAYMENTS_BR,
  permissions: ['administrator', 'agent'],
};

const ordersPaymentsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/orders-payments'),
      component: OrdersPaymentsRouteView,
      children: [
        {
          path: '',
          name: 'orders_payments_index',
          meta,
          component: OrdersPaymentsInboxListPage,
        },
        {
          path: ':inboxId/orders',
          name: 'orders_payments_list',
          meta,
          component: OrdersListPage,
        },
        {
          path: ':inboxId/orders/:orderId',
          name: 'orders_payments_detail',
          meta,
          component: OrdersDetailPage,
        },
      ],
    },
  ],
};

export default ordersPaymentsRoutes;
